import React from 'react'

const SvgSmileFaceFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-9.931 2.984c.922-.034 1.788-.448 2.28-1.052a1 1 0 111.551 1.262c-.902 1.11-2.34 1.736-3.757 1.789-1.437.053-2.97-.483-3.972-1.848a1 1 0 011.612-1.184c.54.736 1.384 1.067 2.286 1.033zm-2.07-4.296a1 1 0 11-2 0 1 1 0 012 0zm5 1a1 1 0 100-2 1 1 0 000 2z'
    />
  </svg>
)

export default SvgSmileFaceFilled
